export default "__VITE_ASSET__CJ$QnqTj__"